export const IMPORT_EXPORT_DICOM_DETAILS_FILE_URI = 'https://mvpublicfiles.blob.core.windows.net/docs/MVision DICOM de-identification table.pdf';
export const SERVICE_AGREEMENT_FILE_URI = '/files/MVision Web Demo Service Agreement.pdf';
